import React, { FC } from 'react';
import { logEvent } from '@/analytics';
import BottomSheet from '@/components/BottomSheet';
import Button from '@/components/Button';
import { useLogout } from '@/hooks/useLogout';

export interface ILogoutBottomSheetContentProps {}

const LogoutBottomSheetContent: FC<ILogoutBottomSheetContentProps> = () => {
  const { logout, isLoading } = useLogout();

  return (
    <div>
      <div className="text-sm font-regular text-gray-120">
        برای خروج از حساب کاربری خود مطمئن هستید؟
      </div>
      <div className="mt-10 flex flex-row items-center gap-x-2">
        <Button
          analytics={['LOGOUT_CONFIRM']}
          color="error"
          id="profile_submit_logout"
          isLoading={isLoading}
          variant="outline"
          isFullWidth
          onClick={logout}
        >
          خروج
        </Button>

        <Button isFullWidth onClick={() => BottomSheet.close()}>
          بازگشت
        </Button>
      </div>
    </div>
  );
};

export const openLogoutBottomSheetContent = () => {
  logEvent('LOGOUT');
  return BottomSheet.open({ children: <LogoutBottomSheetContent /> });
};

export default LogoutBottomSheetContent;
